import { STAC_DASHBOARD_URL } from '../config/env';

export function postLoginRedirectUrl(): string {
  return `${STAC_DASHBOARD_URL}/auth/callback`;
}
